// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","802":"94726e6d"}[chunkId] || chunkId) + "-" + {"532":"8f64ac91f213ca37749f","678":"81af4ec807f95302ba69","802":"7757e6f013ed890f9180","954":"b1774452382412e59727"}[chunkId] + ".js";
};